<div [matTooltip]="text" matTooltipPosition="above" class="wrapper">
  <div class="icon">?</div>
</div>
